module.exports = __webpack_public_path__ + "img/fashion_16.7ce8a4ee.jpg";